import React, {useState, useEffect} from 'react';
import { Paper, Stepper, Step, StepLabel, Typography, CircularProgress, Divider, Button, CssBaseline } from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom';
import useStyles from "./styles";
import AddressForm from '../AddressForm';
import PaymentForm from '../PaymentForm';
import {commerce} from '../../../lib/commerce';

const steps = ['Dirección de envio', 'Detalles de pago'];

const Checkout = ({cart, order, onCaptureCheckout, error}) => {
  const [activeStep, setActiveStep] = useState(0);
  const [checkoutToken, setCheckoutToken] = useState(null);
  const [shippingData, setShippingData] = useState({});
  // const [isFinished, setIsFinished] = useState(false);
  const classes = useStyles();
  const history = useHistory();

  useEffect(() =>  {
    const generateToken = async () => {
      try {
        const token = await commerce.checkout.generateToken(cart.id, { type: 'cart'});
        //console.log(token);
        setCheckoutToken(token);
      } catch (error) {
        history.push('/');
      }
    }
    generateToken();
  }, [cart]);

  const nextStep = () => setActiveStep ((prevActiveStep) => prevActiveStep + 1);

  const backStep = () => setActiveStep((prevActiveStep) => prevActiveStep - 1);

  const next = (data) => {
    setShippingData(data);
    nextStep();
  }

  // const timeout = () => {
  //   setTimeout(() => {
  //     setIsFinished(true)
  //   }, 3000);
  // }

  let Confirmation = () => order.customer ? (
    <>
      <div>
        <Typography variant="h5">Gracias por su compra, {order.customer.firstname} {order.customer.lastname} </Typography>
        <Divider className={ classes.divider } />
        <Typography variant="subtitle2"> Referencia: {order.customer_reference} </Typography> 
      </div>
      <br />
      <Button  component={Link} to="/" variant="outlined" type="button" >Seguir comprando</Button>
    </>
  ) : (
    <div className={classes.spinner}>
      <CircularProgress  /> 
    </div>
  );

  if(error) {
    return (
      <>
        <Typography variant="h5">Error: {error}</Typography>
        <br />
        <Button component={Link} to="/" variant="outlined" type="button">
          Seguir comprando
        </Button>
      </>
    );
  }

  const Form = () => activeStep === 0
    ? <AddressForm checkoutToken = {checkoutToken} next={next} />
    : <PaymentForm shippingData={shippingData} checkoutToken={checkoutToken} nextStep={nextStep} backStep={backStep} onCaptureCheckout={onCaptureCheckout}  />

  return (
    <>
    <CssBaseline />
      <div className = {classes.toolbar} />
      <main className = {classes.layout} >
        <Paper className = {classes.paper}>
          <Typography variant="h4" align="center">
            Verificación
          </Typography>
          <Stepper activeStep={activeStep} className={classes.stepper}>
            {steps.map((step) => (
              <Step key={step}>
                <StepLabel>{step}</StepLabel>
              </Step>
            ))}
          </Stepper>
          {activeStep === steps.length ? <Confirmation /> : checkoutToken &&  <Form />}
        </Paper>
      </main>
    </>
  );
}

export default Checkout;
